import { styled, DialogTitle as DialogTitleMUI, Typography } from '@mui/material';

import { Button } from 'components';

export const DialogTitle = styled(DialogTitleMUI)(({ theme }) => ({
  color: theme.palette.primary.p080,
  fontWeight: 400,
  fontSize: '24px',
  lineHeight: '24px',
  paddingTop: '16px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  marginBottom: '32px',

  svg: {
    marginRight: '24px',
  },
  [theme.breakpoints.down('desktop')]: {
    marginBottom: '16px',
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '28px',
  },
}));

export const GroupTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '18px',
  lineHeight: '24px',
  color: theme.palette.primary.p080,
  marginBottom: '24px',
  [theme.breakpoints.down('desktop')]: {
    marginBottom: '8px',
  },
}));

export const ModalOverlay = styled('div')`
  position: fixed;
  z-index: 1300;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);

  @media (max-width: 1023px) {
    top: 207px;
    padding-bottom: 207px;
  }
`;

export const ModalContent = styled('div')`
  width: 746px;
  height: auto;
  padding: 32px 24px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  margin: 97px auto;

  @media (max-width: 1023px) {
    width: calc(100% - 16px);
    margin: 0 auto 24px;
    padding: 16px 8px 24px;
  }
`;

export const PhoneInputW = styled('div')`
  position: relative;
  flex: 1;
`;

export const SpinnerW = styled('div')`
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 10px;
  margin-right: 16px;
  cursor: not-allowed;
  background-color: ${({ theme }) => theme.palette.info.p030};
  position: absolute;
`;

export const Footer = styled(Typography)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FormButtonsWrapper = styled('div')`
  display: flex;
  gap: 12px;
  margin-left: auto;
  margin-top: 16px;
`;

export const CancelBtn = styled(Button)`
  text-transform: none;
  border-radius: 8px;
  padding: 10px 32px;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.primary.p080};
  border-color: ${({ theme }) => theme.palette.primary.light};
  background: ${({ theme }) => theme.palette.white.main};

  &:hover {
    background: ${({ theme }) => theme.palette.white.p100};
    border-color: ${({ theme }) => theme.palette.primary.p030};
  }
`;

export const CreateBtn = styled(Button)`
  text-transform: none;
  border-radius: 8px;
  padding: 10px 32px;
  font-weight: 600;
  font-size: 16px;
  background: ${({ theme }) => theme.palette.info.main};
  color: ${({ theme }) => theme.palette.white.main};

  &:hover {
    background: ${({ theme }) => theme.palette.info.dark};
  }

  &:disabled {
    background: ${({ theme }) => theme.palette.info.p030};
    color: ${({ theme }) => theme.palette.white.main};
  }
`;
